export default __webpack_public_path__ + "static/screens-2fd69efb3c8b97452976259d46127c7c.png";